/* eslint-disable */
import { defaultApiInstance } from '@/compositions/api';

export function getObjectPrivilege(objectName) {
  return defaultApiInstance.get(`v1/privilege/${objectName}`);
}
